import { render, staticRenderFns } from "./Coordos.vue?vue&type=template&id=20956d76&scoped=true"
import script from "./Coordos.vue?vue&type=script&lang=js"
export * from "./Coordos.vue?vue&type=script&lang=js"
import style0 from "./Coordos.vue?vue&type=style&index=0&id=20956d76&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20956d76",
  null
  
)

export default component.exports